<template>
<div>
    <div class="card-body">
        <b-row>
            <b-col md="12">
                <b-form @submit="onSubmit" autocomplete="off" class="no-printable">
                    <h4 class="font-weight-bold mt-3">{{$t('klanten.instellingen')}}</h4>
                    <b-form-group label-cols-lg="4" :label="$t('klanten.startdatumfacturatie')" label-for="startDate">
                        <datepicker id="startDate" class="col-auto form-control" v-model="command.startDate" placeholder="dd-mm-yyyy"/>
                        <validation element="startDate" />
                    </b-form-group>
                    <b-form-group label-cols-lg="4" :label="$t('klanten.abonnement')" label-for="subscription">
                        <b-form-select id="subscription" v-if="subscriptions" v-model="command.subscriptionType">
                            <option value="">{{$t('klanten.selecteereenabonnement')}}</option>
                            <option :key="index" :value="subscription.id" v-for="(subscription, index) in subscriptions">{{ subscription.name }}</option>
                        </b-form-select>
                        <validation element="subscription" />
                    </b-form-group>
                    <!-- Submit controls -->
                        <b-button type="submit" class="float-right" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                    <!-- Submit controls -->
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <h4 class="font-weight-bold mt-5">{{$t('klanten.vastekosten')}}</h4>
                <b-table class="table-hover" show-empty :items="invoices.fixedCosts" :fields="fieldsFixedCosts">
                    <template v-slot:cell(name)="data">{{ data.item.name }}</template>
                    <template v-slot:cell(priceAgreementType)="data">{{ data.item.priceAgreementType | agreementType }}</template>
                    <template v-slot:cell(price)="data">{{ data.item.price | currency }}</template>
                    <template v-slot:cell(cycleInMonths)="data">{{ data.item.cycleInMonths | cycle }}</template>
                    <template v-slot:cell(total)="data"><strong>{{ data.item.price * data.item.quantity | currency }}</strong></template>
                    <template v-slot:foot(name)="">
                        <strong>{{$t('klanten.totaal')}}</strong>
                    </template>
                    <template v-slot:custom-foot="">
                        <b-tr>
                            <b-td class="text-left bg-light border-top">
                                <strong>{{$t('klanten.kostenpermaand')}}</strong>
                            </b-td>
                            <b-td colspan="5" variant="light" class="text-left bg-light border-top">
                                <strong>{{ totalFixedMonthCosts | currency }}</strong>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td class="text-left bg-light">
                                <strong>{{$t('klanten.kostenperkwartaal')}}</strong>
                            </b-td>
                            <b-td colspan="5" variant="light" class="text-left bg-light">
                                <strong>{{ totalFixedQuarterCosts | currency }}</strong>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td class="text-left bg-light">
                                <strong>{{$t('klanten.kostenperjaar')}}</strong>
                            </b-td>
                            <b-td colspan="5" variant="light" class="text-left bg-light">
                                <strong>{{ totalFixedYearCosts | currency }}</strong>
                            </b-td>
                        </b-tr>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <h4 class="font-weight-bold mt-5">{{$t('klanten.variabelekosten')}}</h4>
                <h5 class="font-weight-bold mt-3">{{$t('priceagreements.prijsafspraken')}}</h5>
                <b-table class="table-hover" show-empty :items="invoices.variableCosts" :fields="fieldsVariableCosts" v-if="invoices.variableCosts">
                    <template v-slot:cell(name)="data">{{ data.item.name }}</template>
                    <template v-slot:cell(priceAgreementType)="data">{{ data.item.priceAgreementType | agreementType }}</template>
                    <template v-slot:cell(price)="data">{{ data.item.price | currency }}</template>
                    <template v-slot:cell(cycleInMonths)="data">{{ data.item.cycleInMonths | cycle }}</template>
                </b-table>
            </b-col>
        </b-row>
        <b-row v-if="invoices.invoiceScans && invoices.invoiceScans.length">
            <b-col md="12">
                <h5 class="font-weight-bold mt-3">{{$t('klanten.verbruikscan')}}</h5>
                <b-table class="table-hover" head-variant="light" show-empty :items="invoices.invoiceScans" :fields="fieldsVariableUse" v-if="invoices.invoiceScans" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                    <template v-slot:cell(cost)="data">{{ data.item.cost | currency }}</template>
                    <template v-slot:cell(totalCost)="data">{{ data.item.totalCost | currency }}</template>
                </b-table>
            </b-col>
        </b-row>
        <b-row v-if="invoices.proccessedInvoices && invoices.proccessedInvoices.length">
            <b-col md="12">
                <h5 class="font-weight-bold mt-3">{{$t('klanten.verbruikfactuur')}}</h5>
                <b-table class="table-hover" head-variant="light" show-empty :items="invoices.proccessedInvoices" :fields="fieldsVariableUse" v-if="invoices.proccessedInvoices" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                    <template v-slot:cell(cost)="data">{{ data.item.cost | currency }}</template>
                    <template v-slot:cell(totalCost)="data">{{ data.item.totalCost | currency }}</template>
                </b-table>
            </b-col>
        </b-row>
        <b-row v-if="invoices.attachmentScans && invoices.attachmentScans.length">
            <b-col md="12">
                <h5 class="font-weight-bold mt-3">{{$t('klanten.verbruikbijlage')}}</h5>
                <b-table class="table-hover" head-variant="light" show-empty :items="invoices.attachmentScans" :fields="fieldsVariableUse" v-if="invoices.attachmentScans" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                    <template v-slot:cell(cost)="data">{{ data.item.cost | currency }}</template>
                    <template v-slot:cell(totalCost)="data">{{ data.item.totalCost | currency }}</template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from "vuex";

//Import command
import Command from "./command";
// import moment from "moment";

export default {
    name: "invoices",
    data() {
        return {
            command: {},
            priceAttachmentScan: '',
            priceInvoiceScan:'',
            priceProcessedInvoiceScan: '',
            monthAttachmentScans: [],
            monthInvoiceScans: [],
            monthProccessedInvoiceScans: [],
            title: "Facturatie",
            
            sortBy: 'monthuse',
            sortDesc: true,
            totalFixedMonthCosts: 0,
            totalFixedQuarterCosts: 0,
            totalFixedYearCosts: 0,
        };
    },
    computed: {
        fieldsFixedCosts() {
            return [{
                    key: 'name',
                    label: this.$i18n.t('datatables.naam'),
                    sortable: true
                },
                {
                    key: 'priceAgreementType',
                    label: this.$i18n.t('datatables.type'),
                    sortable: true
                },
                {
                    key: 'price',
                    label: this.$i18n.t('datatables.tarief'),
                    sortable: true
                },
                {
                    key: 'quantity',
                    label: this.$i18n.t('carpetline.aantal'),
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: 'cycleInMonths',
                    label: this.$i18n.t('datatables.cyclus'),
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: 'total',
                    label: this.$i18n.t('datatables.totaal'),
                    class: 'bg-light border-left '
                }
            ]
        },
        fieldsVariableCosts() { 
            return [{
                    key: 'name',
                    label: this.$i18n.t('datatables.naam'),
                    sortable: true
                },
                {
                    key: 'priceAgreementType',
                    label: this.$i18n.t('datatables.type'),
                    sortable: true
                },
                {
                    key: 'price',
                    label: this.$i18n.t('datatables.tarief'),
                    sortable: true
                },
                {
                    key: 'cycleInMonths',
                    label: this.$i18n.t('datatables.cyclus'),
                    sortable: true,
                    class: 'text-center'
                }
            ]
        },
        fieldsVariableUse() { 
            return [{
                    key: 'period',
                    label: this.$i18n.t('datatables.periode'),
                    sortable: true
                },
                {
                    key: 'totalUse',
                    label: this.$i18n.t('datatables.totaalverbruik'),
                    sortable: true
                },
                {
                    key: 'count',
                    label: this.$i18n.t('carpetline.aantal'),
                    sortable: true
                },
                {
                    key: 'cost',
                    label: this.$i18n.t('datatables.tarief'),
                    sortable: true,
                },
                {
                    key: 'totalCost',
                    label: this.$i18n.t('datatables.totaal'),
                    sortable: true,
                    thClass: 'border-left',
                    tdClass: 'bg-light border-left font-weight-bold'
                },
            ]
        },
        subscriptions() {
            return [
                {
                    id: '1',
                    name: 'Basis FM (old)'
                },
                {
                    id: '2',
                    name: 'Basis FM (new)'
                },
                {
                    id: '3',
                    name: this.$i18n.t('klanten.proef')
                },
                {
                    id: '4',
                    name: this.$i18n.t('klanten.inkijk')
                },
            ]
        },
        ...mapGetters ('fm', ['invoices', 'settings']),
    },
    methods: {
        ...mapActions('fm', ['all', 'create', 'update', 'delete']),
        totalPrice: function () {
            return this.priceAgreementsCustomer.map(x => x.priceAgreement.price).reduce((a, b) => a + b, 0);
        },
        calcTotalFixedMonthCosts: function () {
            if(this.invoices.length != 0) {
                this.totalFixedMonthCosts = this.invoices.fixedCosts.filter(x => x.cycleInMonths == 1 && x.price ).map(x => x.price * x.quantity ).reduce((a, b) => a + b, 0);
            }
        },
        calcTotalFixedQuarterCosts: function () {
            if(this.invoices.length != 0) {
                this.totalFixedQuarterCosts = this.invoices.fixedCosts.filter(x => x.cycleInMonths == 3 && x.price ).map(x => x.price * x.quantity ).reduce((a, b) => a + b, 0);
            }
        },
        calcTotalFixedYearCosts: function () {
            if(this.invoices.length != 0) {
                this.totalFixedYearCosts = this.invoices.fixedCosts.filter(x => x.cycleInMonths == 12 && x.price ).map(x => x.price * x.quantity ).reduce((a, b) => a + b, 0);
            }
        },
        variableCosts: function () {
            return this.priceAgreementsCustomer.filter(function (priceAgreementCustomer) {
                return priceAgreementCustomer.priceAgreement.isVariable
            })
        },
        fixedCosts: function () {
            return this.priceAgreementsCustomer.filter(function (priceAgreementCustomer) {
                return !priceAgreementCustomer.priceAgreement.isVariable
            })
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;
            let date = vm.$options.filters.formatDateTime(vm.command.startDate, "YYYY-MM-DD");
            vm.command.startDate = date

            let payload = { 
                resource: "settings",
                params: vm.command
            };

            var action = vm.command.id ? vm.update(payload) : vm.create(payload);
            action.then(() => {
                vm.$store.dispatch('fm/all', {
                    resource: 'settings'
                });
            });

        }
    },
    created() {
        let vm = this;
        vm.all({
            resource: 'invoices'
        });
        vm.all({
            resource: 'settings'
        });
    },
    mounted() {
        let vm = this;
        if(vm.settings.length == 0) {
            vm.all({
                resource: 'settings'
            }).then(()=> {
                vm.command = new Command(vm.settings[0]);
            });
        }
        vm.command = new Command(vm.settings[0]);
    },
    updated() {
        this.$nextTick( () => {
            let vm = this;
            vm.calcTotalFixedMonthCosts();
            vm.calcTotalFixedQuarterCosts();
            vm.calcTotalFixedYearCosts();
        })
    }
};
</script>
